"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FourthCurrentStep = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const atome_1 = require("../../../components/atome");
const Breakpoints_1 = require("../../../helper/Breakpoints");
const GlobalStyles_1 = require("../../../helper/GlobalStyles");
const Dashboard_web_style_1 = require("./Dashboard.web.style");
const FourthCurrentStep = (props) => {
    const { userInformation, scrollToAktuel } = props;
    return (react_1.default.createElement(react_native_1.View, { onLayout: event => {
            const layout = event.nativeEvent.layout;
            scrollToAktuel(layout.x, layout.y, layout.width, layout.height, !Breakpoints_1.isMobileOrTablet ? true : false);
        } },
        react_1.default.createElement(atome_1.Text, { style: [Dashboard_web_style_1.styles.heading3, GlobalStyles_1.globalStyles.marginTop25] }, "Ihre Videosprechstunde"),
        react_1.default.createElement(atome_1.Text, { style: [Dashboard_web_style_1.styles.text] }, "Ihre Videosprechstunde wurde gebucht."),
        react_1.default.createElement(react_native_1.View, { style: [
                GlobalStyles_1.globalStyles.row,
                Dashboard_web_style_1.styles.appointmentContainer,
                !Breakpoints_1.isMobileOrTablet ? undefined : GlobalStyles_1.globalStyles.marginLeft15,
                !Breakpoints_1.isMobileOrTablet
                    ? GlobalStyles_1.globalStyles.marginVertical50
                    : Dashboard_web_style_1.styles.mobileCalendar,
                GlobalStyles_1.globalStyles.alignCenter,
            ] },
            react_1.default.createElement(react_native_1.View, { style: [
                    !Breakpoints_1.isMobileOrTablet
                        ? GlobalStyles_1.globalStyles.positionRelative
                        : GlobalStyles_1.globalStyles.marginLeft25,
                ] },
                react_1.default.createElement(atome_1.Icon, { icon: 'calendar', size: !Breakpoints_1.isMobileOrTablet ? 90 : 60 }),
                react_1.default.createElement(atome_1.Text, { style: [
                        Dashboard_web_style_1.styles.text,
                        GlobalStyles_1.globalStyles.textBold,
                        GlobalStyles_1.globalStyles.positionAbsolute,
                        Dashboard_web_style_1.styles.heading2,
                        Dashboard_web_style_1.styles.appointmentDay,
                    ] }, new Date(userInformation.appointment[userInformation?.appointment?.length - 1].startDate)
                    .getDate()
                    .toLocaleString('de-DE', {
                    minimumIntegerDigits: 2,
                }))),
            react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.flex2, GlobalStyles_1.globalStyles.marginLeft25] },
                react_1.default.createElement(atome_1.Text, { style: [Dashboard_web_style_1.styles.containerHeader, GlobalStyles_1.globalStyles.width100] }, new Date(userInformation.appointment[userInformation?.appointment?.length - 1].startDate).toLocaleDateString('de-DE', {
                    day: '2-digit',
                    month: 'long',
                    year: 'numeric',
                }) +
                    (!Breakpoints_1.isMobileOrTablet ? ' um ' : '\num ') +
                    new Date(userInformation?.appointment[userInformation?.appointment?.length - 1].startDate).toLocaleTimeString('de-DE', {
                        hour: '2-digit',
                        minute: '2-digit',
                    }) +
                    ' Uhr'),
                react_1.default.createElement(atome_1.Text, { style: [Dashboard_web_style_1.styles.containerText] },
                    "Arzt: ",
                    userInformation.appointment[0].doctorTitle,
                    ' ',
                    userInformation.appointment[userInformation?.appointment?.length - 1].doctorName))),
        react_1.default.createElement(atome_1.Text, { style: [Dashboard_web_style_1.styles.text] }, "Bitte erscheinen Sie f\u00FCnf Minuten vor dem Termin in der Videosprechstunde."),
        react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.flex2] },
            react_1.default.createElement(react_native_1.TouchableOpacity, { style: [Dashboard_web_style_1.styles.button, GlobalStyles_1.globalStyles.marginTop25] },
                react_1.default.createElement(atome_1.Link, { href: `https://esprechstunde.net/termin/${userInformation.appointment[userInformation?.appointment?.length - 1].esprechstundeCode}` },
                    react_1.default.createElement(atome_1.Text, { style: [Dashboard_web_style_1.styles.buttonText] }, "Zur Videosprechstunde"))))));
};
exports.FourthCurrentStep = FourthCurrentStep;
